module.exports = __webpack_public_path__ + "img/zte.8644138a.png";